import React from "react";
import { Plus } from "lucide-react";
import ReportForm from "./components/ReportForm";

const AddReport = () => {
  return <ReportForm isEdit={false} submitIcon={Plus} />;
};

export default AddReport;
